import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../shared/colors';

export const useStyles = makeStyles( theme => ({
    "btn-primary": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.dhcsBlue,
                "&:hover": {
                    color: colors.dhcsTealDark,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.dhcsBlue,
                '&:hover':{
                    backgroundColor: colors.dhcsTealDark,
                }
            }
        }
    },
    "btn-secondary": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.magellanDeepGreen,
                "&:hover": {
                    color: colors.magellanDeepGreen,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.magellanDeepGreen,
                '&:hover':{
                    backgroundColor: colors.magellanDeepGreen,
                }
            }
        }
    },
    "btn-danger": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.californiaRed,
                "&:hover": {
                    color: colors.californiaRed,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.magellanRed,
                '&:hover':{
                    backgroundColor: colors.magellanRed,
                }
            }
        }
    },
    "btn-info": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.magellanDarkGray,
                "&:hover": {
                    color: colors.magellanDarkGray,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.magellanLightGray,
                color: colors.magellanBlack,
                '&:hover':{
                    backgroundColor: colors.magellanLightGray,
                    color: colors.magellanBlack
                }
            }
        }
    }
}));
